import Swal from 'sweetalert2';

/**
 * Set global so you don't have to import it
 */
window.swal = Swal;

